import React from "react";

const SplashLoader = () => {
  return (
    <div className="flex h-screen">
      <span className="relative m-auto flex h-20 w-20">
        <span className="animate-ZoomOut absolute left-[4%] -top-[4%] h-full inline-flex w-full rounded-full bg-primary opacity-75"></span>
        <img
          src={"/Logos/aurepsi-logo.svg"}
          alt="splashLogo"
          className="relative inline-flex"
        />
      </span>
    </div>
  );
};

export default SplashLoader;
